import { Tooltip } from 'antd';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { TFunction } from 'i18next';
import React from 'react';
import classes from '../DocumentsResearch.module.scss';
import { documnentIcons } from 'helpers/documentIcons';

export const getInfoColumns = (t: TFunction) => [
  {
    title: t('Report.info.key'),
    dataIndex: 'key',
    key: 'key',
    width: '50%',
  },
  {
    title: t('Report.info.value'),
    dataIndex: 'current',
    key: 'current',
    width: '50%',
  },
];


export const getCompareColumns = (t: TFunction) => [
  {
    title: t('Report.info.key'),
    dataIndex: 'key',
    key: 'key',
    width: '33%',
  },
  {
    title: t('Report.info.previous'),
    dataIndex: 'previous',
    key: 'previous',
    width: '35%',
  },
  {
    title: t('Report.info.current'),
    dataIndex: 'current',
    key: 'current',
    width: '32%',
  },
];

export const getDocumentInfoColumns = (onRoomClick?: () => void, t?: (key: string) => string) => [
  {
    title: '',
    dataIndex: 'key',
    key: 'key',
    width: '40%',
    render: (text: string) => React.createElement('strong', null, text),
  },
  {
    title: '',
    dataIndex: 'value',
    key: 'value',
    width: '60%',
    render: (value: string, record: any) => {
      if (record.key === t?.('Report.info.room') && onRoomClick && value && value !== '-') {
        return (
          <Tooltip title={t?.('Report.info.roomNavigation')}>
            <span
              onClick={onRoomClick}
              style={{
                color: '#1890ff',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
            >
              {value}
            </span>
          </Tooltip>
        );
      }
      return value;
    }
  }
];

const ComparisonIndicator = ({ previous, current }: { previous: string; current: string }) => {
  const isEqual = previous === current;
  return (
    <div className={classes.comparisonIndicator}>
      {isEqual ? (
        <CheckCircleFilled style={{ color: '#52c41a', fontSize: '20px' }} />
      ) : (
        <CloseCircleFilled style={{ color: '#ff4d4f', fontSize: '20px' }} />
      )}
    </div>
  );
};

const CellWithLabel = ({ label, value, isChanged }: { label: string; value: string; isChanged?: boolean }) => (
  <div className={classes.cellContainer}>
    <div className={classes.cellLabel}>{label}</div>
    <div className={`${classes.cellValue} ${isChanged ? classes.changedCell : ''}`}>
      {value}
    </div>
  </div>
);

export const getDocumentComparisonColumns = (
  t: TFunction, 
  getIcon: (extension: string) => keyof typeof documnentIcons,
  previousExtension?: string,
  currentExtension?: string
) => [
  {
    title: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
        {previousExtension && (
          <span style={{ fontSize: '16px' }}>
            {documnentIcons[getIcon(previousExtension)]}
          </span>
        )}
        <span>{t('Report.info.previous')}</span>
      </div>
    ),
    dataIndex: 'previous',
    key: 'previous',
    width: '40%',
    render: (value: string, record: any) => (
      <CellWithLabel 
        label={record.label} 
        value={value}
      />
    )
  },
  {
    title: '',
    key: 'indicator',
    width: '20%',
    align: 'center' as const,
    render: (_: any, record: any) => (
      <ComparisonIndicator 
        previous={record.previous} 
        current={record.current} 
      />
    )
  },
  {
    title: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
        {currentExtension && (
          <span style={{ fontSize: '16px' }}>
            {documnentIcons[getIcon(currentExtension)]}
          </span>
        )}
        <span>{t('Report.info.current')}</span>
      </div>
    ),
    dataIndex: 'current',
    key: 'current',
    width: '40%',
    render: (value: string, record: any) => {
      const isChanged = record.previous !== record.current;
      return (
        <CellWithLabel 
          label={record.label} 
          value={value}
          isChanged={isChanged}
        />
      );
    }
  }
];
